import React from 'react'
import ItemsContainer from '../ItemsContainer/ItemsContainer'
import SingleItemBox from '../SingleItemBox/SingleItemBox'
import AyurEncylcopediaImage from '../../assets/images/ayur-encyclopedia.png'
import HomeoEncyclopediaImage from '../../assets/images/homeo-encyclopedia.png'
import SymptomChecker from '../../assets/images/symptom-checker.png'
import DoctorImage from '../../assets/images/doctor.png'
import BlogImage from '../../assets/images/blogImage.png'
import RecipesImage from '../../assets/images/receipe.png'
import MeditationImage from '../../assets/images/meditation.svg'

const FirstBox = () => {
  return (
    <ItemsContainer>
      <SingleItemBox image={AyurEncylcopediaImage} text='Ayurvedic Encyclopedia' />
      <SingleItemBox image={HomeoEncyclopediaImage} text='Homeopathy Encyclopedia' />
      <SingleItemBox image={SymptomChecker} text={'Symptoms Checker'} />
      <SingleItemBox image={DoctorImage} text='Practitioners Directory' />
      <SingleItemBox image={BlogImage} text='Blog' />
      <SingleItemBox image={RecipesImage} text='Remedies Guides' />
      <SingleItemBox image={MeditationImage} text='Meditation Guides' />
    </ItemsContainer>
  )
}

export default FirstBox